exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.font-small[data-v-ad09c0fe] {\n    font-size: .95em;\n}\n.submit-icon[data-v-ad09c0fe] {\n    font-size: 1.2em;\n}\n.secure-email[data-v-ad09c0fe] {\n    position: relative;\n    top: 4px;\n    left: -5px;\n}\n.secure-email-text[data-v-ad09c0fe] {\n    position: relative;\n    left: -9px;\n}\n.lock[data-v-ad09c0fe] {\n    position: relative;\n    top: 3px;\n    left: 7px;\n    color: #bcbcbc;\n    font-size: 0.75em;\n}\n", ""]);

// exports
